<template>
  <span :class="['quotazione', 'font-weight-bold', { small }]">
    Q {{ quotazione }}
  </span>
</template>

<script>
export default {
  name: "quotazione",
  props: {
    quotazione: {
      type: [Number, String],
      default: null,
    },
    small: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
.quotazione {
  background: var(--quotazione-tranparent-background);
  border-radius: 4px;
  color: var(--quotazione-text);
  display: inline-flex;
  font-size: 11px;
  justify-content: center;
  white-space: nowrap;
  padding: 2px 6px;
}

.quotazione.small {
  flex: 0 0 auto;
  font-size: 9px;
  line-height: 1;
  padding: 2px 4px;
}
</style>
